import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";

type Notification = {
  user_photos: [{
    picture:string
  }];
  user_photos_to: [{
    picture:string
    
  }];
  id: number;
  message: string;
  type: string;
  is_read: boolean;
  receiver_id:number;
  request_id:number;
  createdAt: string;
  user?: {
    id: number;
    name: string;
    profile_image: string;
  };
};

type NotificationState = {
  notifications: Notification[];
  loading: boolean;
  error: string | null;
  total: number;
  getNotifications: (params: {
    userId: string;
    page?: number;
    limit?: number;
    isRead?: boolean;
    type?: string;
  }) => Promise<void>;
  markSeenNotification:(params: {
    userId: number;
    type?: string;
  }) => Promise<void>;
};

export const useInAppNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  loading: false,
  error: null,
  total: 0,

  getNotifications: async ({ userId, page = 0, limit = 10, isRead, type }) => {
    set({ loading: true, error: null });

    try {
      const params: any = {
        userId,
        page,
        limit,
      };

      if (isRead !== undefined) params.isRead = isRead;
      if (type) params.type = type;

      const response = await axiosInstance.get("/get-notifications", { params });

      set({
        notifications: response.data.data,
        total: response.data.total,
        loading: false,
      });
    } catch (err: any) {
      const message = err.response?.data?.message || "Failed to fetch notifications";
      set({ error: message, loading: false });
    }
  },
  markSeenNotification: async ({ userId, type }) => {
    set({ loading: true, error: null });

    try {
      const params: any = {
        userId,
        type
      };
      await axiosInstance.post("/markSeenNotification", { params });

  
    } catch (err: any) {
     
    }
  },
}));
